export const stripHtmlFromString = (slug) => {
    if (slug === null || slug === undefined) {
        return '';
    }
    return slug.replace(/(<([^>]+)>)/gi, '');
};
